let menuList = [
    {
        key: '1',
        name: "手动对焊机系列",
        list: [{
            key: '1-1',
            name: "XS-250-2H/XS-250-4H"
        },
        {
            key: '1-2',
            name: "XS-160-2H/XS-200-2H/XS-160-4H/XS-200-4H"
        },
        ]
    },
    {
        key: '2',
        name: "螺杆式对焊机系列",
        list: [{
            key: '2-1',
            name: "XS-LG160-2H/XS-LG160-2H/XS-LG160-4H/XS-LG200-4H"
        },
        {
            key: '2-2',
            name: "XS-LG250-2H/XS-LG250-4H"
        },
        ]
    },
    //  {
    //     key: '3',
    //     name: "承插焊机",
    //     list: [{
    //         key: '3-1',
    //         name: "160 承插焊机"
    //     },
    //     ]
    // }, 
    {
        key: '4',
        name: "手推焊机系列",
        list: [
            {
                key: '4-1',
                name: "XS-ST160-2H/SX-ST200-2H/SX-CC160"
            },

        ]
    },
    {
        key: '5',
        name: "同层排水焊机系列",
        list: [{
            key: '5-1',
            name: "XS-TC160"
        },
        {
            key: '5-2',
            name: "XS-HDPE200"
        },
        {
            key: '5-3',
            name: "XS-HDPE160/XS-HDPE315"
        },

        ]
    },
    {
        key: '6',
        name: "全自动电熔焊机系列",
        list: [{
            key: '6-1',
            name: "QD400/QD630/QD750/QD1200/QD1600"
        },
        {
            key: '6-2',
            name: "XS-400"
        },
        {
            key: '6-3',
            name: "XS-HDPE160/XS-HDPE315"
        },

        ]
    },
    {
        key: '7',
        name: "全自动热熔焊机",
        list: [{
            key: '7-1',
            name: "XS-Q200-250-315-400-450-500"
        },

        ]
    },
    {
        key: '8',
        name: "半自动液压对焊机系列",
        list: [{
            key: '8-1',
            name: "XS-YY160/XS-YY200/XS-YY250"
        },
        {
            key: '8-2',
            name: "XS-YH400/XS-YH450/XS-YH500/XS-YH630"
        },
        {
            key: '8-3',
            name: "XS-YH315/XS-YH355"
        },
        {
            key: '8-4',
            name: "XS-YH800/XS-YH1000/XS-YH1200"
        },
        {
            key: '8-5',
            name: "XS-YH1600/XS-YH2000"
        },
        ]
    },
    {
        key: '9',
        name: "多角度管件热熔焊机系列",
        list: [{
            key: '9-1',
            name: "XS-W315/XS-W450/XS-W630/XS-W800"
        }, {
            key: '9-2',
            name: "XS-315H/XS-630H/XS-800H/XS-1000H"
        },

        ]
    },
    {
        key: '11',
        name: "PPR热熔器",
        list: [{
            key: '11-1',
            name: "20-63mm恒温/20-32mm恒温/20-63mm调温"
        }, {
            key: '11-2',
            name: "75-110mm调温/20-63mm调温"
        }, {
            key: '11-3',
            name: "75-110mm恒温/20-32mm调温"
        }
        ]
    },
    {
        key: '10',
        name: "焊接设备辅助工具",
        list: [{
            key: '10-1',
            name: "可调三通电熔支架"
        }, {
            key: '10-2',
            name: "紧接管/电熔支架"
        },
        //  {
        //     key: '10-3',
        //     name: "割刀"
        // },
        //  {
        //     key: '10-4',
        //     name: "环形切刀"
        // },
        // {
        //     key: '10-5',
        //     name: "刨边器"
        // },
        // {
        //     key: '10-6',
        //     name: "升降滚架"
        // },
        {
            key: '10-7',
            name: "旋转刮刀"
        },
        // {
        //     key: '10-8',
        //     name: "止气夹"
        // },
        // {
        //     key: '10-9',
        //     name: "多角度带锯"
        // },
        // {
        //     key: '10-10',
        //     name: "PPR热熔器"
        // },
        {
            key: '10-11',
            name: "管道工具"
        },
        {
            key: '10-12',
            name: "配件"
        },
        ]
    },

]


let list = [
    {
        img: [
            require("../../assets/product/aa1.jpg")
        ],
        title: "XS-250-2H/XS-250-4H",
        name: '手动对焊机系列',
        key: '1-1',
        contents: [],
    },

    {
        img: [
            require("../../assets/product/aa2.jpg"),

        ],
        name: '手动对焊机系列',
        key: '1-2',
        title: "XS-160-2H/XS-200-2H/XS-160-4H/XS-200-4H",
        contents: [

        ],
    },
    {
        img: [
            require("../../assets/product/2-1.jpg"),

        ],
        name: '螺杆式对焊机系列',
        title: "XS-LG160-2H/XS-LG160-2H/XS-LG160-4H/XS-LG200-4H",
        key: '2-1',
        contents: [

        ],
    },
    {
        img: [
            require("../../assets/product/2-2.jpg"),

        ],
        name: '螺杆式对焊机系列',
        title: "XS-LG250-2H/XS-LG250-4H",
        key: '2-2',
        contents: [

        ],
    },
    {
        img: [
            require("../../assets/product/j1.jpeg"),
            require("../../assets/product/j2.jpeg"),
        ],
        title: "160 承插焊机",
        key: '3-1',
        contents: [
            "适应于在工地，沟槽中连接PE、PP、PVDF管材与管材，管材与管件，也可以在车问使用；",
            "全铝加厚机架，4cm全铝夹瓦，带保压稳固螺丝；",
            "大功率铣刀，特种橡胶电源线，带弹套保护装置；",
            "加厚加热板（不低于18mm），特种橡胶电源线，大金特氟龙涂料不粘管。",
        ],
    },
    {
        img: [
            require("../../assets/product/4-1.jpg"),

        ],
        name: "手推焊机系列",
        title: "XS-ST160-2H/SX-ST200-2H/SX-CC160",
        key: '4-1',
        contents: [

        ],
    },
    {
        img: [
            require("../../assets/product/l1.jpeg"),
            require("../../assets/product/l2.jpeg"),
        ],
        title: "手推热熔焊机200-2M",
        key: '4-2',
        contents: [
            "适应于在工地，沟槽中连接PE、PP、PVDF管材与管材，管材与管件，也可以在车问使用；",
            "全铝加厚机架，4cm全铝夹瓦，带保压稳固螺丝；",
            "大功率铣刀，特种橡胶电源线，带弹套保护装置；",
            "加厚加热板（不低于18mm），特种橡胶电源线，大金特氟龙涂料不粘管。",
        ],
    },
    {
        img: [
            require("../../assets/product/5-1.jpg"),

        ],
        title: "XS-TC160",
        key: '5-1',
        name: "同层排水焊机系列",
        contents: [

        ],
    },
    {
        img: [
            require("../../assets/product/5-2.jpg"),

        ],
        title: "XS-HDPE200",
        name: "同层排水焊机系列",
        key: '5-2',
        contents: [

        ],
    },
    {
        img: [
            require("../../assets/product/5-3.jpg"),

        ],
        name: "同层排水焊机系列",
        title: "XS-HDPE160/XS-HDPE315",
        key: '5-3',
        contents: [

        ],
    },

    {
        img: [
            require("../../assets/product/6-1.jpg"),

        ],
        name: "全自动电熔焊机系列",
        title: "QD400/QD630/QD750/QD1200/QD1600",
        key: '6-1',
        contents: [

        ],
    },
    {
        img: [
            require("../../assets/product/6-2.jpg"),

        ],
        name: "全自动电熔焊机系列",
        title: "XS-400",
        key: '6-2',
        contents: [

        ],
    },
    {
        img: [
            require("../../assets/product/5-3.jpg"),

        ],
        name: "全自动电熔焊机系列",
        title: "XS-HDPE160/XS-HDPE315",
        key: '6-3',
        contents: [

        ],
    },
    {
        img: [
            require("../../assets/product/7-1.jpg"),

        ],
        name: "全自动热熔焊机",
        title: "XS-Q200-250-315-400-450-500",
        key: '7-1',
        contents: [

        ],
    },
    {
        img: [
            require("../../assets/product/8-1.jpg")
        ],
        title: "XS-YY160/XS-YY200/XS-YY250",
         name: "半自动液压对焊机系列",
        key: '8-1',
        contents: [

        ],
    },
    {
        img: [
            require("../../assets/product/8-2.jpg")
        ],
        title: "XS-YH400/XS-YH450/XS-YH500/XS-YH630",
        key: '8-2',
         name: "半自动液压对焊机系列",
        contents: [

        ],
    },
    {
        img: [
            require("../../assets/product/8-3.jpg")
        ],
        title: "XS-YH315/XS-YH355",
         name: "半自动液压对焊机系列",
        key: '8-3',
        contents: [

        ],
    },
    {
        img: [
            require("../../assets/product/8-4.jpg")
        ],
        title: "XS-YH800/XS-YH1000/XS-YH1200",
         name: "半自动液压对焊机系列",
        key: '8-4',
        contents: [

        ],
    },
    {
        img: [
            require("../../assets/product/8-5.jpg")
        ],
        title: "XS-YH1600/XS-YH2000",
         name: "半自动液压对焊机系列",
        key: '8-5',
        contents: [

        ],
    },
    {
        img: [
            require("../../assets/product/9-1.jpg")
        ],
        title: "XS-W315/XS-W450/XS-W630/XS-W800",
        key: '9-1',
         name: "多角度管件热熔焊机系列",
        contents: [

        ],
    },
    {
        img: [
            require("../../assets/product/10-9.jpg")
        ],
        title: "XS-W315/XS-W450/XS-W630/XS-W800",
        key: '9-2',
         name: "多角度管件热熔焊机系列",
        contents: [

        ],
    },
    {
        img: [
            require("../../assets/product/10-1.jpg")
        ],
        title: "可调三通电熔支架",
        key: '10-1',
        contents: [

        ],
    },
    {
        img: [
            require("../../assets/product/10-2.jpg")
        ],
        title: "紧接管/电熔支架",
        name: "焊接设备辅助工具",
        key: '10-2',
        contents: [

        ],
    },
    {
        img: [
            require("../../assets/product/c-1.jpg")
        ],
        title: "割刀",
        key: '10-3',
        contents: [

        ],
    },
    {
        img: [
            require("../../assets/product/d-1.jpg")
        ],
        title: "环形切刀",
        key: '10-4',
        contents: [

        ],
    },
    {
        img: [
            require("../../assets/product/e-1.jpg")
        ],
        title: "刨边器",
        key: '10-5',
        contents: [

        ],
    },
    {
        img: [
            require("../../assets/product/f-1.jpg")
        ],
        title: "升降滚架",
        key: '10-6',
        contents: [

        ],
    },
    {
        img: [
            require("../../assets/product/10-7.jpg")
        ],
        title: "旋转刮刀",
        key: '10-7',
        contents: [

        ],
    },
    {
        img: [
            require("../../assets/product/h-1.jpg")
        ],
        title: "止气夹",
        key: '10-8',
        contents: [

        ],
    },
    // {
    //     img: [
    //         require("../../assets/product/10-9.jpg")
    //     ],
    //     title: "多角度带锯",
    //     key: '10-9',
    //     contents: [

    //     ],
    // },
    {
        img: [
            require("../../assets/product/10-10-1.jpg"),
            require("../../assets/product/10-10-2.jpg"),
            require("../../assets/product/10-10-3.jpg"),
        ],
        title: "PPR热熔器",
        key: '10-10',
        contents: [

        ],
    },
    {
        img: [
            require("../../assets/product/10-11-1.jpg"),
            require("../../assets/product/10-11-2.jpg"),

        ],
        title: "管道工具",
        key: '10-11',
        contents: [

        ],
    },
    {
        img: [
            require("../../assets/product/10-12.jpg"),

        ],
        title: "配件",
        key: '10-12',
        contents: [

        ],
    },
    {
        img: [
            require("../../assets/product/10-10-2.jpg"),

        ],
        title: "20-63mm恒温/20-32mm恒温/20-63mm调温",
        key: '11-1',
        contents: [

        ],
    },
    {
        img: [
            require("../../assets/product/10-10-1.jpg"),

        ],
        title: "75-110mm调温/20-63mm调温",
        key: '11-2',
        contents: [

        ],
    },
    {
        img: [
            require("../../assets/product/10-10-3.jpg"),

        ],
        title: "75-110mm恒温/20-32mm调温",
        key: '11-3',
        contents: [

        ],
    },
]
export default {
    list, menuList
}